
import { expressURL } from "../lib/Constants";

export const verify = async (payload: any): Promise<any> => {
    const res = await fetch(`${expressURL}/api/recaptcha`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
    });
    if(!res.ok) {
        console.error("Errore nella verifica del recaptcha");
        return false;
    }
    return true;
};